import { UserFormRow } from '@anm/styles/helpers';
import { Config as FinalFormConfig } from 'final-form';
import { FC } from 'react';
import { Form, FormRenderProps } from 'react-final-form';
import styled from 'styled-components';

import ButtonLoader from '../../buttons/ButtonLoader';
import FormHelperText from '../FormHelperText';
import PasswordBlock from '../PasswordBlock';
import { ConfirmPasswordField, RequiredPasswordField } from '../fields';

type HOCs = FinalFormConfig;
export type ChangePasswordFormProps = {
  isPending?: boolean;
  submitError?: string | null;
};

export type ChangePasswordFormFields = {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
};

const ChangePasswordButton = styled(ButtonLoader)`
  margin-bottom: 20px;
`;

const renderForm = ({ submitError, isPending = false }: ChangePasswordFormProps) => ({
  values,
  handleSubmit,
  touched,
  errors,
  active
}: FormRenderProps) => {
  return (
    <form onSubmit={handleSubmit}>
      <>
        {submitError && (
          <UserFormRow>
            <FormHelperText variant="static">{submitError}</FormHelperText>
          </UserFormRow>
        )}

        <UserFormRow>
          <RequiredPasswordField
            name="currentPassword"
            label="Current password"
            helperTextVariant="belowField"
            maxLength={60}
          />

          <PasswordBlock
            name="newPassword"
            label="New password"
            errors={errors}
            touched={touched}
            password={values.newPassword}
            activeField={active}
            helperTextVariant="belowField"
            direction="to-bottom"
          />
          <ConfirmPasswordField newPassword={values.newPassword} helperTextVariant="belowField" maxLength={60} />
          <ChangePasswordButton
            buttonType="submit"
            size="large_long_static"
            variant="blue-heavy-border"
            isPending={isPending}
          >
            Save Changes
          </ChangePasswordButton>
        </UserFormRow>
      </>
    </form>
  );
};

const ChangePasswordForm: FC<HOCs & ChangePasswordFormProps> = props => <Form render={renderForm(props)} {...props} />;

export default ChangePasswordForm;
